(function(){
function initRv(sc){
 if(sc.__rv)return;var tr=sc.querySelector('.cg-track');if(!tr)return;sc.__rv=1;
 sc.classList.add('is-js');
 if(window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches)return;
 var half=0,x=0,last=0,lu=0,hov=false,vis=true,raf=0,touching=false,ramp=0,lastSet=-100,wasIdle=false;
 function m(){half=(tr.scrollWidth+16)/2}
 function u(){lu=performance.now();ramp=0}
 sc.addEventListener('touchstart',function(){touching=true;u()},{passive:true});
 sc.addEventListener('touchend',function(){touching=false;u()},{passive:true});
 sc.addEventListener('touchcancel',function(){touching=false;u()},{passive:true});
 ['wheel','pointerdown','keydown'].forEach(function(e){sc.addEventListener(e,u,{passive:true})});
 sc.addEventListener('scroll',function(){if(Math.abs(sc.scrollLeft-lastSet)>2.5)u()},{passive:true});
 sc.addEventListener('mouseenter',function(){hov=true});
 sc.addEventListener('mouseleave',function(){hov=false;u()});
 function t(n){raf=0;if(!vis)return;if(!last)last=n;var d=Math.min((n-last)/1000,0.05);last=n;if(!half)m();
  var sp=window.innerWidth<750?60:35;
  var idle=!hov&&!touching&&(performance.now()-lu>1500);
  if(!idle){wasIdle=false;ramp=0}
  else{
   if(!wasIdle){x=sc.scrollLeft;wasIdle=true}
   ramp=Math.min(1,ramp+d/1.2);
   var e=ramp*ramp*(3-2*ramp);
   x+=sp*e*d;if(half&&x>=half)x-=half;
   lastSet=x;sc.scrollLeft=x;
  }
  raf=requestAnimationFrame(t)}
 if('IntersectionObserver' in window){new IntersectionObserver(function(en){vis=en[0].isIntersecting;if(vis&&!raf){last=0;wasIdle=false;raf=requestAnimationFrame(t)}}).observe(sc)}
 window.addEventListener('resize',m);window.addEventListener('load',m);
 raf=requestAnimationFrame(t);
}
function bootRv(){document.querySelectorAll('.cg-slider-wrapper').forEach(initRv)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bootRv);else bootRv();
})();
(function(){
if(window.__smCardHover)return;window.__smCardHover=true;
var mq=window.matchMedia&&window.matchMedia('(hover:hover)');
if(!mq||!mq.matches)return;
function main(card){return card.querySelector('.sm-card__img img:not(.sm-card__img2)');}
function prep(card){
 if(card.__smReady)return;card.__smReady=true;
 var m=main(card),s=card.querySelector('.sm-card__img2');
 if(m&&s){var cs=getComputedStyle(m);s.style.objectPosition=cs.objectPosition;s.style.objectFit=cs.objectFit;}
 card.querySelectorAll('.sm-sw i[data-img]').forEach(function(i){var im=new Image();im.src=i.getAttribute('data-img');});
}
document.addEventListener('mouseover',function(e){
 var card=e.target.closest&&e.target.closest('.sm-card');
 if(!card)return;
 prep(card);
 var sw=e.target.closest('.sm-sw i[data-img]');
 if(!sw)return;
 var m=main(card);if(!m)return;
 if(!m.__o){m.__o={src:m.getAttribute('src'),srcset:m.getAttribute('srcset'),sizes:m.getAttribute('sizes')};}
 m.removeAttribute('srcset');m.removeAttribute('sizes');
 m.setAttribute('src',sw.getAttribute('data-img'));
 card.classList.add('is-sw');
 card.querySelectorAll('.sm-sw i.is-on').forEach(function(x){x.classList.remove('is-on');});
 sw.classList.add('is-on');
});
document.addEventListener('mouseout',function(e){
 var box=e.target.closest&&e.target.closest('.sm-sw');
 if(!box||box.contains(e.relatedTarget))return;
 var card=box.closest('.sm-card');if(!card)return;
 var m=main(card);
 if(m&&m.__o){var o=m.__o;if(o.srcset)m.setAttribute('srcset',o.srcset);if(o.sizes)m.setAttribute('sizes',o.sizes);m.setAttribute('src',o.src);m.__o=null;}
 card.classList.remove('is-sw');
 box.querySelectorAll('i.is-on').forEach(function(x){x.classList.remove('is-on');});
});
})();
